/**
 * Sunstow theme mode — light / dark with localStorage + system fallback.
 */
(function () {
  const KEY = 'sunstow-theme';
  const root = document.documentElement;

  function preferred() {
    const saved = localStorage.getItem(KEY);
    if (saved === 'light' || saved === 'dark') return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function apply(mode) {
    root.setAttribute('data-sunstow-theme', mode);
    const buttons = document.querySelectorAll('[data-sunstow-theme-toggle]');
    buttons.forEach((btn) => {
      btn.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        mode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
      );
    });
  }

  function toggle() {
    const next = root.getAttribute('data-sunstow-theme') === 'dark' ? 'light' : 'dark';
    localStorage.setItem(KEY, next);
    apply(next);
  }

  // Early apply (also duplicated inline in head to avoid FOUC)
  apply(preferred());

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-sunstow-theme-toggle]');
    if (!btn) return;
    toggle();
  });

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    if (localStorage.getItem(KEY)) return;
    apply(e.matches ? 'dark' : 'light');
  });

  // Subtle interactive: parallax sun rays on hero
  const hero = document.querySelector('.sunstow-hero');
  const rays = document.querySelector('.sunstow-hero__rays');
  if (hero && rays && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    hero.addEventListener('pointermove', (e) => {
      const rect = hero.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      rays.style.transform = `translate(${x * 18}px, ${y * 12}px) rotate(${x * 8}deg)`;
    });
  }
})();
